import { USER_FIELDS_BY_TABS, USER_FIELDS } from 'constants/user-form';
import { dateValidator, getDefaultValues } from 'helpers';
import { USER_DETAILS_FIELDS } from 'constants/user-details';

export const getDefaultFormValues = (user) => {
  const questions = Object.keys(USER_DETAILS_FIELDS).reduce(
    (acc, k) => {
      const userFields = USER_DETAILS_FIELDS[k];
      return [...acc, ...userFields];
    },
    [...USER_FIELDS],
  );

  return getDefaultValues(questions, user);
};

export const hasFieldsInTab = (tab, user) => {
  return R.any(
    (f) => !R.isNil(user[f.key] || user[f.altKey]),
    USER_FIELDS_BY_TABS[tab],
  );
};

export const validateProfileForm = (values) => {
  let valid = USER_FIELDS.reduce((acc, { key }) => {
    if (!values[key]) {
      return R.assoc(key, true, acc);
    }
    return acc;
  }, null);
  if (!dateValidator(values.dateOfBirth)) {
    valid = R.assoc('dateOfBirth', true, valid);
  }
  return valid;
};
